import * as React from "react";

import { getItemGroupData } from "../../../Helpers/table";
import { AttributeGroup, DataGridContent } from "../../../Models";
import DataGrid from "../DataGrid";
import EditableItemGroup from "./EditableItemGroup";
import PaginatedItemGroup from "./PaginatedItemGroup";
import SparePartItemGroup from "./SparePartItemGroup";
import TabbedItemGroup from "./TabbedItemGroup";
import DocumentItemGroup from "./DocumentItemGroup";
import SiteAssetsItemGroup from "./SiteAssetsItemGroup";
import AvailableServicesItemGroup from "./AvailableServicesItemGroup";

type ItemGroupProps = {
    attributeGroup: AttributeGroup;
    filterable?: boolean;
    sortable?: boolean;
    className?: string;
};

const ItemGroup: React.FC<ItemGroupProps> = (props: ItemGroupProps) => {
    const dataGridContent: DataGridContent = getItemGroupData(
        props.attributeGroup.headers,
        props.attributeGroup.rows
    );
    const extraClass: string = props.className ? props.className : "";

    return (
        <div className={`ItemGroup ${extraClass}`}>
            <h3 className="ItemGroup__title">{props.attributeGroup.name}</h3>

            <DataGrid
                filterable={props.filterable}
                isSortable={props.sortable}
                showPagination={false}
                content={dataGridContent}
            />
        </div>
    );
};

export default ItemGroup;

export {
    EditableItemGroup,
    PaginatedItemGroup,
    SparePartItemGroup,
    TabbedItemGroup,
    DocumentItemGroup,
    SiteAssetsItemGroup,
    AvailableServicesItemGroup,
};
